import { IPoiData } from "./interfaces";
import { IStoreItem } from "./store/interfaces";

let lastId = 0;

export function getMapContentStoreId(): IStoreItem["id"] {
	const newId = lastId;

	lastId++;

	return newId;
}

export function getEventCoords(evt: PointerEvent | TouchEvent) {
	if ((evt as TouchEvent).touches?.length) {
		const touches = (evt as TouchEvent).touches[0];
		const xVal = touches.clientX >>> 0;
		const yVal = touches.clientY >>> 0;

		return {
			x: xVal,
			y: yVal,
		};
	}

	const xVal = (evt as PointerEvent).offsetX >>> 0;
	const yVal = (evt as PointerEvent).offsetY >>> 0;

	return {
		x: xVal,
		y: yVal,
	};
}

export function poiInfoToJson(poiInfo: Module.IPoiInfo): IPoiData {
	return {
		id: poiInfo.id,
		source: poiInfo.source,
		title: poiInfo.title,
		mark: {
			lon: poiInfo.markWgs.x,
			lat: poiInfo.markWgs.y,
		},
		markMerc: {
			lon: poiInfo.markMerc.x,
			lat: poiInfo.markMerc.y,
		},
		position: {
			lon: poiInfo.contactPosWgs.x,
			lat: poiInfo.contactPosWgs.y,
		},
		positionMerc: {
			lon: poiInfo.contactPosMerc.x,
			lat: poiInfo.contactPosMerc.y,
		},
	};
}

export function createBtn(text: string, cb: () => void) {
	const button = document.createElement("button");

	button.type = "button";
	button.textContent = text;
	button.addEventListener("click", () => {
		cb();
	});

	return button;
}

// opacity 0-1
// 0-1
export function decOpacityToHex(opacity: number) {
	const hexValue = (opacity / 1) * 255 >>> 0;

	return hexValue.toString(16);
}

// opacity 0-1
export function setOpacity(hashColor: string, opacity: number): string {
	return `${hashColor}${decOpacityToHex(opacity)}`;
}

export function getRemovedIds(allIds: Array<IStoreItem["id"]>, usedIds: Array<IStoreItem["id"]>) {
	return allIds.filter(item => !usedIds.includes(item));
}

export function getImageCanvas(src: string): Promise<{
	canvas: HTMLCanvasElement;
	img: HTMLImageElement;
	setNumber: (value: number) => ImageData;
	getImageData: () => ImageData;
}> {
	return new Promise((resolve, reject) => {
		const img = new Image();

		img.addEventListener("load", () => {
			const canvas = document.createElement("canvas");

			canvas.width = img.naturalWidth;
			canvas.height = img.naturalHeight;

			const ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0);

			const getImageData = () => ctx.getImageData(0, 0, canvas.width, canvas.height);
			const setNumber = (value: number) => {
				ctx.drawImage(img, 0, 0);
				ctx.font = "48px Arial";
				ctx.fillStyle = "black";
				ctx.fillText(value.toString(), 10, 40);
				//ctx.fillRect(25, 25, 25, 25);

				/*const img2 = new Image();

				img2.src = canvas.toDataURL();
				document.body.append(img2);*/

				return getImageData();
			};

			resolve({
				canvas,
				img,
				getImageData,
				setNumber,
			});
		});
		img.addEventListener("error", () => {
			reject({});
		});
		img.src = src;
	});
}

export function getRandomIcon() {
	const random = 1 + (Math.random() * 200 >>> 0);

	return `https://api.mapy.com/poiimg/icon/${random}?scale=2`;
}
